import styled from 'styled-components'
// eslint-disable-next-line no-unused-vars
import { InputProps } from './index'

const InputStyled = styled.input<InputProps>`
  background-color: #e2e4ea;
  height: ${(p) => p.height};
  width: ${(p) => p.width};
  margin: 10px;
  border-radius: 5px;
  outline: 0;
  border: 2px solid #8e97cc;

  :focus {
    border: 2px solid #424f94;
    background-color: #bfc5ea;
  }
`
export default InputStyled
